<template>
    <nav>
        <ul class="nav-plano">
            <li>
                <label>{{ $trad.plano.editor.header.file.label }}</label>
                <ul>
                    <li :disabled="locked" @click="$emit('save');">{{ $trad.plano.editor.header.file.save }}</li>
                    <li @click="$emit('saveAs');">{{ $trad.plano.editor.header.file.saveAs }}</li>
                    <li v-if="hasAccessCreate('template_builder')" @click="$emit('saveAsTemplate');">
                        {{ $trad.plano.editor.header.file.saveAsTemplate }}
                    </li>
                    <li v-if="plano" :disabled="locked" @click="showEditNameModal = true;">
                        {{ $trad.plano.editor.header.file.renamePlanogram.labelMenu }}
                    </li>
                    <hr />
                    <li @click="exit">{{ $trad.plano.editor.header.file.exit }}</li>
                </ul>
            </li>
            <li>
                <label>{{ $trad.plano.editor.header.export.label }}</label>
                <ul>
                    <li @click="$emit('exportPdf');">{{ $trad.plano.editor.header.export.exportPdf }}</li>
                    <hr />
                    <li @click="$emit('exportXls');">{{ $trad.plano.editor.header.export.exportExcel }}</li>
                </ul>
            </li>
            <li>
                <label>{{ $trad.plano.editor.header.window.label }}</label>
                <ul>
                    <li :checked="showToolbar" @click="showToolbar = !showToolbar;">{{ $trad.plano.editor.header.window.toolbar }}</li>
                    <li :checked="showLibrary" @click="showLibrary = !showLibrary;">{{ $trad.plano.editor.header.window.library }}</li>
                    <li :checked="showNewbieTool" @click="showNewbieTool = !showNewbieTool;">{{ $trad.plano.editor.header.window.dummies }}</li>
                </ul>
            </li>
            <li>
                <label>{{ $trad.plano.editor.header.help.label }}</label>
                <ul>
                    <li @click="showShortcutsModal = true;">{{ $trad.plano.editor.header.help.shortcutList.label }}</li>
                    <li @click="displayInfo">{{ $trad.plano.editor.header.help.fileInfo }}</li>
                    <li>{{ $trad.plano.editor.header.help.help }}</li>
                </ul>
            </li>
            <li><LangSelector></LangSelector></li>
        </ul>
        <ModalShortcuts v-if="showShortcutsModal" @close="showShortcutsModal = false;"></ModalShortcuts>
        <ModalEditPlanoName
            v-if="showEditNameModal"
            :plano="plano"
            @close="showEditNameModal = false;"
            @nameChanged="nameChanged"
        ></ModalEditPlanoName>
    </nav>
</template>

<script>
import ModalEditPlanoName from "./modal/modalEditPlanoName";
import ModalShortcuts from "./modal/shortcuts";
import { Context } from "plano_engine";
import LangSelector from "@/components/langSelector/langSelector";
import cacheService from "@/services/cache";

export default {
    props: { exitTo: { type: String, required: true }, locked: Boolean, plano: Object },
    components: { ModalEditPlanoName, LangSelector, ModalShortcuts },
    data: () => ({
        showEditNameModal: false,
        showShortcutsModal: false,
        showToolbar: cacheService.get("showToolbar") !== "false",
        showLibrary: cacheService.get("showLibrary") !== "false",
        showNewbieTool: cacheService.get("showNewbieTool") !== "false"
    }),
    watch: {
        showToolbar(value) {
            cacheService.set("showToolbar", value);
            if (Context.commands) {
                Context.commands.root.node.style = `display:${value ? "visible" : "none"}`;
            }
        },
        showLibrary(value) {
            cacheService.set("showLibrary", value);
            if (Context.catalog) {
                Context.catalog.root.node.style = `display:${value ? "visible" : "none"}`;
            }
        },
        showNewbieTool(value) {
            cacheService.set("showNewbieTool", value);
            if (Context.newbieTool) {
                Context.newbieTool.root.node.style = `display:${value ? "visible" : "none"}`;
            }
        }
    },
    mounted() {
        Promise.waitUntil(() => Context.commands).then(() => {
            Context.commands.root.node.style = `display:${this.showToolbar ? "visible" : "none"}`;
        });
        Promise.waitUntil(() => Context.catalog).then(() => {
            Context.catalog.root.node.style = `display:${this.showLibrary ? "visible" : "none"}`;
        });
        Promise.waitUntil(() => Context.newbieTool).then(() => {
            Context.newbieTool.root.node.style = `display:${this.showNewbieTool ? "visible" : "none"}`;
        });
    },
    methods: {
        exit() {
            this.$router.push(this.exitTo);
        },
        nameChanged(name) {
            this.$emit("nameChanged", name);
        },
        print() {
            Context.print();
        },
        displayInfo() {
            Context.canvas.openModal(displayInfo, {}, data => {});
        }
    }
};
</script>

<style lang="scss" scoped>
nav {
    // TODO: dark light
    background-color: #333;
    color: #e8e8e8;

    height: 40px;
    // show sub menus above planogram
    z-index: 1;
    box-shadow: #333 0px 4px 11px -2px;

    ul {
        list-style-type: none;
    }

    > ul {
        margin: 0;
        padding: 0;
        display: flex;

        & > li {
            position: relative;
            line-height: 40px;
            height: 40px;
            padding: 0 20px;
            text-transform: uppercase;

            &:last-child {
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            &:hover:not(:last-child) {
                background-color: var(--color4);
            }

            ul {
                display: none;
                background-color: #333;
                position: absolute;
                top: 40px;
                left: 5px;
                padding: 0;
                padding-bottom: 6px;
                box-shadow: #333 0px 4px 11px -2px;
                border-radius: 0 0 2px 2px;

                li {
                    text-transform: none;
                    padding: 0 20px;
                    height: 22px;
                    line-height: 22px;
                    min-width: 150px;
                    white-space: nowrap;
                    cursor: pointer;

                    &[disabled] {
                        color: #999;
                        pointer-events: none;
                    }

                    &[checked]::before {
                        content: "✓";
                        font-size: 16px;
                        display: inline-block;
                        width: 19px;
                        margin-left: -14px;
                        margin-right: -5px;
                    }

                    &:hover:not([disabled]) {
                        background-color: #555;
                    }
                }

                hr {
                    margin: 0 15px;
                    border-bottom: 1px solid #999;
                }
            }

            &:active,
            &:hover {
                ul {
                    display: initial;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// plano-nav.vue?04091d06